"use strict";

exports.__esModule = true;
exports.default = void 0;
var _group = _interopRequireDefault(require("./_group.js"));
var _has = _interopRequireDefault(require("./_has.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Groups the object's values by a criterion. Pass either a string attribute
// to group by, or a function that returns the criterion.
var _default = exports.default = (0, _group.default)(function (result, value, key) {
  if ((0, _has.default)(result, key)) result[key].push(value);else result[key] = [value];
});